import { render, staticRenderFns } from "./ResetPasswordFaq.vue?vue&type=template&id=4cf2c24f&scoped=true"
import script from "./ResetPasswordFaq.vue?vue&type=script&lang=js"
export * from "./ResetPasswordFaq.vue?vue&type=script&lang=js"
import style0 from "./ResetPasswordFaq.vue?vue&type=style&index=0&id=4cf2c24f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cf2c24f",
  null
  
)

export default component.exports